import React, { Component, Fragment } from 'react';
import UserAddressPanel from './UserAddressPanel'
import LoadingPanel from '../../../utility_components/LoadingPanel';
import SelectUSState from '../../../utility_components/us-states-selector-fork/src/SelectUSState';
export default class AddressSelector extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isValid: false,
            address:{
                address: '',
                address2: '',
                city: '',
                state: '',
                zip: ''
            },
            loading: true
        };
        this.updateServiceType = this.updateServiceType.bind(this);
        this.handleAddressLine1Change = this.handleAddressLine1Change.bind(this);
        this.handleAddressLine2Change = this.handleAddressLine2Change.bind(this);
        this.handleCityChange = this.handleCityChange.bind(this);
        this.handleStateChange = this.handleStateChange.bind(this);
        this.handleZipChange = this.handleZipChange.bind(this);
        this.isValid = this.isValid.bind(this);
        this.loggedInUpdateServiceType = this.loggedInUpdateServiceType.bind(this);
        this.getAddressesForUser = this.getAddressesForUser.bind(this);
        this.handleEnterKeypress = this.handleEnterKeypress.bind(this);
        this.setLoadingFalse = this.setLoadingFalse.bind(this);
    }

    handleAddressLine1Change(e) {
        let shallow = this.state.address;
        shallow.address = e.target.value;
        this.setState({address: shallow});
    }

    handleAddressLine2Change(e) {
        let shallow = this.state.address;
        shallow.address2 = e.target.value;
        this.setState({address: shallow});
    }

    handleCityChange(e) {
        let shallow = this.state.address;
        shallow.city = e.target.value;
        this.setState({address: shallow});
    }

    handleStateChange(value) {
        let shallow = this.state.address;
        shallow.state = value;
        this.setState({address: shallow});
    }

    handleZipChange(e) {
        let shallow = this.state.address;
        shallow.zip = e.target.value;
        this.setState({address: shallow});
    }

    updateServiceType(e) {
        e.preventDefault();
        if(this.isValid()) {
            let address = this.state.address;
            this.props.postServiceType(address);
        }
    }

    loggedInUpdateServiceType(address) {
        this.props.postServiceType(address);
    }

    isValid() {
        //This is dumb but we need some _minimal_ checking
        let validity = true;
        if(this.state.address.address.length < 4) validity = false;
        if(this.state.address.city.length < 2) validity = false;
        if(this.state.address.state.length < 2) validity = false;
        if(this.state.address.zip.length < 5) validity = false;
        return validity;
    }

    getAddressesForUser() {
        let url = `${window.relativeURI()}/user/addresses/api`;
        fetch(url, {
            method: 'GET'
        }).then( (fetchResponse) => {
            if(fetchResponse.status > 300 && fetchResponse.status < 400) document.location.reload(); //Follow redirects
            if(fetchResponse.ok) {
                fetchResponse.json().then( (resJson) => {
                    let shouldContinue = this.props.userType === 'user';
                    this.setState({addresses: resJson, loading: shouldContinue}, () => {
                        if(this.props.userType === 'user') {
                            //Means we still need to gather user data
                            let url = window.relativeURI() + "/user/api";
                            fetch(url, {method: 'GET'}).then( (response) => {
                                if(response.status > 300 && response.status < 400) document.location.reload(); //Follow redirects
                                if(response.ok) {
                                    response.json().then( (resJ) => {
                                        this.setState({userData: resJ, loading: false});
                                    }, (jsonParseFailure) => {
                                        console.log('json parser failed');
                                        console.log(jsonParseFailure);
                                    })
                                }else {
                                    console.log(response.status);
                                }
                            }, (fetchFailure) => {
                                console.log('fetch response failed');
                                console.log(fetchFailure);
                            })
                        }
                    });
                }, (jsonParseFailure) => {
                    console.log('json parser failed');
                    console.log(jsonParseFailure);
                })
            }
        }, (fetchFailure) => {
            console.log(fetchFailure);
        });
    }

    setLoadingFalse() {
        this.setState({loading: false});
    }

    componentDidMount() {
        if(window.session.user_authenticated && !window.session.is_guest){
            this.getAddressesForUser();
        }else {
            this.setLoadingFalse();
        }
    }

    handleEnterKeypress(e) {
        if(e.keyCode == 13){
            this.updateServiceType();
        }
    }

    render() {
        if(this.state.loading) return <LoadingPanel />
        if(this.props.userAuthenticated) {
            let temporaryAddress = this.state.addresses && this.state.addresses.length > 0 ? this.state.addresses[0] : {
                address: '',
                address2: '',
                city: '',
                state: '',
                zip: '',
                displayName: '',
                deliveryInstructions: '',
                id: -99
            };
        return (
        <UserAddressPanel userType={window.session.user_authenticated && window.session.is_guest ? 'guest' : 'user'} tmpAddress={temporaryAddress} addresses={this.state.addresses} setAddressID={this.props.setAddressID}
         backFunction={this.props.goBack} backText='Go Back'
         proceedFunction={this.loggedInUpdateServiceType} proceedText='Set Address' serviceType={this.props.serviceType} />)
        }
        return (
        <div>
            <h2 className={this.props.isDialog ? 'm-2 dialog-title' : 'm-2'}>Enter an Address</h2>
            <div onKeyDown={this.handleEnterKeypress} className='container-fluid'>
                <div className='row'>
                    <input type="text" className='form-control col m-2' placeholder='Address Line 1' onChange={this.handleAddressLine1Change} value={this.state.addressLine1}/>
                    <input type="text" className='form-control col m-2' placeholder='Address Line 2 (optional)' onChange={this.handleAddressLine2Change} value={this.state.addressLine2}/>
                </div>
                <div className="row">
                    <input type="text" className="m-2 form-control col" placeholder='City' onChange={this.handleCityChange} value={this.state.city}/>
                    <div className="col">
                        <SelectUSState id="serviceTypeSelectState" className="m-2 form-control" onChange={this.handleStateChange} value={this.state.state}/>
                    </div>
                </div>
                <div className="row">
                    <input type="text" className="m-2 form-control col" placeholder='Zip' onChange={this.handleZipChange} value={this.state.zip}/>
                </div>
            </div>
            <div className="container">
                <button onClick={this.props.goBack} className='m-3 btn btn-secondary'>Go Back</button>
                <button onClick={this.updateServiceType} className={`m-3 btn btn-primary ${this.isValid() ? '' : 'disabled'}`}>Ok</button>
            </div>
        </div>
        );
    }
}
